// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"0d6b170e","173":"95fe7a46","460":"3597b631","583":"206a19b3"}[chunkId] + ".chunk.css";
};